// extracted by mini-css-extract-plugin
module.exports = {"workflowEditorWrapper":"WorkflowEditorWrapper_workflowEditorWrapper__SywE-","workflowButtonWrapper":"WorkflowEditorWrapper_workflowButtonWrapper__1SGEg"};